import { Card, formatPersianNumber } from '../../../app/components/foundation';
import { Activity, Database, Server } from 'lucide-react';
import type { ReactNode } from 'react';
import type { MonitoringSnapshot } from '../types/monitoring.types';

interface MonitoringLiveSnapshotProps {
  monitoring: MonitoringSnapshot;
  serviceAction?: ReactNode;
}

export function MonitoringLiveSnapshot({ monitoring, serviceAction }: MonitoringLiveSnapshotProps) {
  const services = Object.entries(monitoring.services);

  return (
    <div className="vania-monitoring-snapshot">
      <Card>
        <div className="vania-monitoring-health-header">
          <h2 className="mb-4 text-lg font-semibold">وضعیت سرویس‌ها</h2>
          {serviceAction}
        </div>
        <div className="vania-monitoring-health-matrix">
          {services.map(([name, service]) => (
            <div key={name} className="vania-monitoring-health-matrix__item">
              <div className="vania-monitoring-health-matrix__identity">
                <span className="vania-monitoring-health-matrix__icon" aria-hidden="true">
                  {name === 'api' ? <Server size={16} /> : name === 'database' ? <Database size={16} /> : <Activity size={16} />}
                </span>
                <strong>{name === 'api' ? 'API' : name === 'database' ? 'پایگاه داده' : 'Redis'}</strong>
              </div>
              <span className="vania-monitoring-health-matrix__status"><span className="vania-monitoring-health-matrix__status-dot" aria-hidden="true" />{service.status}</span>
              <small className="vania-monitoring-health-matrix__message">{service.message}</small>
            </div>
          ))}
        </div>
      </Card>
      <Card>
        <h2 className="mb-2 text-lg font-semibold">آمار درخواست‌ها</h2>
        <p>{monitoring.request_metrics.available ? 'در دسترس' : monitoring.request_metrics.message}</p>
      </Card>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <Card><h2 className="mb-2 text-lg font-semibold">خطاهای اخیر</h2><p>{monitoring.recent_errors.length ? formatPersianNumber(monitoring.recent_errors.length) : 'موردی ثبت نشده است'}</p></Card>
        <Card><h2 className="mb-2 text-lg font-semibold">رویدادهای اخیر</h2><p>{monitoring.recent_events.length ? formatPersianNumber(monitoring.recent_events.length) : 'موردی ثبت نشده است'}</p></Card>
      </div>
    </div>
  );
}
